 <!-- Footer -->
 <footer class="footer pt-5 pb-4 pb-lg-5">
    <div class="container pt-lg-4">
      <div class="row pb-5">
        <div class="col-lg-4 col-md-6">
          <div class="navbar-brand text-dark p-0 me-0 mb-3 mb-lg-4">
            <img src="assets/img/logo.svg" width="220" alt="CourseSignage.com">
          </div>
          <p class="fs-sm pb-lg-3 mb-4">Make signs your players will love. Get better ratings on UDisc, secure more funding, and save yourself some headaches. Create all kinds of course signs from tee signs to navigational signs.</p>
          <form class="needs-validation" novalidate>
            <label for="subscr-email" class="form-label">Subscribe to our newsletter</label>
            <div class="input-group">
              <input type="email" id="subscr-email" class="form-control rounded-start ps-5" placeholder="Your email" required>
              <i class="bx bx-envelope fs-lg text-muted position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5"></i>
              <div class="invalid-tooltip position-absolute top-100 start-0">Please provide a valid email address.</div>
              <button type="submit" class="btn btn-primary">Subscribe</button>
            </div>
          </form>
        </div>
        <div class="col-xl-6 col-lg-7 col-md-5 offset-xl-2 offset-md-1 pt-4 pt-md-1 pt-lg-0">
          <div id="footer-links" class="row">
            <div class="col-lg-4">
              <h6 class="mb-2">
                <a href="#useful-links" class="d-block text-dark dropdown-toggle d-lg-none py-2" data-bs-toggle="collapse">Useful Links</a>
              </h6>
              <div id="useful-links" class="collapse d-lg-block" data-bs-parent="#footer-links">
                <ul class="nav flex-column pb-lg-1 mb-lg-3">
                  <li class="nav-item"><a routerLink="/" class="nav-link d-inline-block px-0 pt-1 pb-2">Home</a></li>
                  <li class="nav-item"><a routerLink="/pricing" class="nav-link d-inline-block px-0 pt-1 pb-2">Pricing</a></li>
                  <li class="nav-item"><a routerLink="/contact" class="nav-link d-inline-block px-0 pt-1 pb-2">Contact</a></li>
                </ul>
              </div>
            </div>
            <div class="col-xl-4 col-lg-3">
              <h6 class="mb-2">
                <a href="#social-links" class="d-block text-dark dropdown-toggle d-lg-none py-2" data-bs-toggle="collapse">Socials</a>
              </h6>
              <div id="social-links" class="collapse d-lg-block" data-bs-parent="#footer-links">
                <ul class="nav flex-column mb-2 mb-lg-0">
                  <li class="nav-item"><a href="https://www.facebook.com/coursesignage" class="nav-link d-inline-block px-0 pt-1 pb-2">Facebook</a></li>
                  <li class="nav-item"><a href="https://www.instagram.com/coursesignage/" class="nav-link d-inline-block px-0 pt-1 pb-2">Instagram</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="nav d-block fs-xs text-center text-md-start pb-2 pb-lg-0 mb-0">
        &copy; All rights reserved. Made by  <a class="nav-link d-inline-block p-0" routerLink="/contact" >CourseSignage.com</a>
      </p>
    </div>
  </footer>